import React from 'react'
import Item from './Item'
import { Droppable } from 'react-beautiful-dnd'
import { styled } from '../../../stiches.config'

interface ColumnProps {
  col: {
    id: string
    list: string[]
  }
}

const StyledColumn = styled('div', {
  // padding: '24px 16px',
  display: 'flex',
  flexDirection: 'column',
  marginTop: '8',
  h2: {
    fontFamily: 'Montserrat',
    // fontSize: '12px',
    // color: '#3B3B3B',
    letterSpacing: '0',
    marginLeft: "15px"
  }
},

)

const StyledList = styled('div', {
  backgroundColor: '#ddd',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  marginTop: 8,
  height: "210px",
  width: "260px",
  overflow: "auto",
  background: '#FFFFFF',
  // border: '1px solid #000000',
  // boxShadow: '0 0 6px 0 rgba(0,0,0,0.06)',
  borderRadius: '4px',

})

const Column: React.FC<ColumnProps> = ({ col: { list, id } }) => {
  return (
    <Droppable droppableId={id}>
      {provided => (
        <StyledColumn>
          <div style={{ display: "-webkit-box" }}>
            <h2 style={{
              fontSize: id == "todo" ? "12px" : "14px",
              color: id == "todo" ? "#3B3B3B" : "#8E8E8E",
              fontWeight: id == "todo" ? 600 : 500
            }}>
              {id == "todo" ? "Drag & Drop Fields Here " : id == "doing" ? "Mandatory Fields" : "Optional Fields"}
            </h2>
            {id == "todo" && <img src={require('../../../assets/images/rightArrow.svg')} alt="rightArrow" className="rightArrowIcon" width="22px" height="12px" />}
          </div>
          <StyledList {...provided.droppableProps} ref={provided.innerRef}
            style={{
              border: id == "todo" ? '1px solid #000000' : '1px solid #D6D6D6',
              boxShadow: id == "todo" ? '0 0 6px 0 rgba(0,0,0,0.06)' : 'none'
            }}
          >
            {(list.length == 0 && id !== "todo") &&
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                fontFamily: "Montserrat",
                fontSize: "12px",
                color: "#C6C6C6",
                fontWeight: 600,
                letterSpacing: 0,
                lineHeight: "18px"
              }}>
                1. Drag & Drop Fields <br />
2. Sort Fields
</div>
            }
            {list.map((text, index) => (
              <Item key={text} text={text} index={index} />
            ))}
            {provided.placeholder}
          </StyledList>
        </StyledColumn>
      )}
    </Droppable>
  )
}

export default Column
